import storeutilis from '@/helpers/storeutilis';

export default {
	croppa: state => {
        return state.croppa;
    },

    media_store: state => {
        return state.media_store;
    },

    livepreview: state => {
        return state.livepreview;
    },

    inlinemod: state => {
        return state.inlinemod;
    },

    auto_hide_notifications: state => {
        return state.auto_hide_notifications;
    },
}




// WEBPACK FOOTER //
// ./src/store/features/getters.js